import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import authReducer from "./Reducer/authReducer";
import addCampaignReducer from "./Reducer/addCampaignReducer";
import commonReducer from "./Reducer/commonReducer";
import addWalmartCampaignReducer from "./Reducer/addWalmartCampaignReducer";

//encryptor
const encryptor = encryptTransform({
  secretKey: "b7F2@Xv93!mZpQ1#dL8o$C6wK5YtNgR",
  onError: function (error) {
    console.error(error);
  },
});

const persistConfig = {
  key: "root",
  storage,
  transforms: [encryptor],
};

const rootReducer = combineReducers({
  auth: authReducer,
  addCampaign: addCampaignReducer,
  commonReducer:commonReducer,
  addWalmartCampaign: addWalmartCampaignReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
        ignoredPaths: ["register"],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
